/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A VDK Web utility library. (@accedo/vdkweb-utils) 5.0.2
* 
*******************************************************************************/
"use strict";

var _env = require("./env");

(function () {
  var fn = function () {
    if (!(0, _env.domExists)()) {
      return false;
    }

    var specFunctions;
    var baseFns = ['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'];
    var browserSpecFns = [// new WebKit
    ['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'], // old WebKit (Safari 5.1)
    ['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'], ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']];
    var fns = {};

    for (var i = 0; i < browserSpecFns.length; i += 1) {
      specFunctions = browserSpecFns[i];

      if (specFunctions && specFunctions[1] in document) {
        for (var j = 0; j < specFunctions.length; j += 1) {
          fns[baseFns[j]] = specFunctions[j];
        }

        return fns;
      }
    }

    return false;
  }();

  var fullScreener = {
    /**
     *
     * @param {Element} elem DOM element
     * @param {Object} opts Optional parameters
     * @returns {void}
     */
    enter: function enter(elem, opts) {
      var request = fn.requestFullscreen;
      elem = elem || document.documentElement;
      elem[request](opts);
    },
    exit: function exit() {
      document[fn.exitFullscreen]();
    },
    addChangeListener: function addChangeListener(listener) {
      document.addEventListener(fn.fullscreenchange, listener);
    },
    removeChangeListener: function removeChangeListener(listener) {
      document.removeEventListener(fn.fullscreenchange, listener);
    },
    addErrorListener: function addErrorListener(listener) {
      document.addEventListener(fn.fullscreenerror, listener);
    },
    removeErrorListener: function removeErrorListener(listener) {
      document.removeEventListener(fn.fullscreenerror, listener);
    }
  };

  if (!fn) {
    if ((0, _env.isCommonJs)()) {
      module.exports = false;
    } else {
      window.fullScreener = false;
    }

    return;
  }

  Object.defineProperties(fullScreener, {
    isFullScreen: {
      get: function get() {
        return Boolean(document[fn.fullscreenElement]);
      }
    },
    element: {
      enumerable: true,
      get: function get() {
        return document[fn.fullscreenElement];
      }
    },
    enabled: {
      enumerable: true,
      get: function get() {
        // Coerce to boolean in case of old WebKit
        return Boolean(document[fn.fullscreenEnabled]);
      }
    }
  });

  if ((0, _env.isCommonJs)()) {
    module.exports = fullScreener;
  } else {
    window.fullScreener = fullScreener;
  }
})();